import { Component, Fragment } from "react";
import Tabs from "react-bootstrap/esm/Tabs";
import Tab from 'react-bootstrap/Tab';
import utils from "../../../utils/utils";
import Tabela from "../Tabela";

export default class TabelaRelatorio5 extends Component {

    constructor(props) {
        super(props);

    }

    formataRealizadoMetas = (realizados, metas) => {
        let novo = realizados.map((realizado) => {
            let unidadeFiltro = metas.filter(meta => meta.unidade === realizado.unidade)[0];
            let modalidade = [...new Set([...Object.keys(realizado.modalidades), ...Object.keys(unidadeFiltro.modalidades)])]
            let isVazio = {
                matricula_regimental: 0,
                matricula_nao_regimental: 0,
                matricula_pago: 0,
                hora_regimental: 0,
                hora_nao_regimental: 0,
                hora_pago: 0
            }
            let novasModalidades = {}
            modalidade.map(modal => {
                novasModalidades[modal] = {
                    meta: unidadeFiltro.modalidades[modal] === undefined ? isVazio : unidadeFiltro.modalidades[modal],
                    realizado: realizado.modalidades[modal] === undefined ? isVazio : realizado.modalidades[modal]
                }
            })
            realizado.modalidades = novasModalidades;
            return realizado;
        })
        return realizados;
    }

    calculaTotal = (realizados) => {
        let totaisObj = {}
        let modalidades = realizados;
        let obj = {
            meta: {
                matricula_regimental: 0,
                matricula_nao_regimental: 0,
                matricula_pago: 0,
                hora_regimental: 0,
                hora_nao_regimental: 0,
                hora_pago: 0
            },
            realizado: {
                matricula_regimental: 0,
                matricula_nao_regimental: 0,
                matricula_pago: 0,
                hora_regimental: 0,
                hora_nao_regimental: 0,
                hora_pago: 0
            }
        }
        Object.keys(modalidades).map(modalidade => {
            Object.keys(modalidades[modalidade]['meta']).map(financiamento => obj['meta'][financiamento] += modalidades[modalidade]['meta'][financiamento])
            Object.keys(modalidades[modalidade]['realizado']).map(financiamento => obj['realizado'][financiamento] += modalidades[modalidade]['realizado'][financiamento])
        })

        return obj
    }

    formataRealizadoMetasV2 = (realizados, metas) => {
        let modalidadesEncontradas = {}
        realizados.map(realizado => {
            let modalidades = realizado.modalidades;
            Object.keys(modalidades).map(modalidade => {
                if(realizado.unidade === 'DR') return // não somar com o DR
                if(modalidadesEncontradas.hasOwnProperty(modalidade)) {
                    Object.keys(modalidades[modalidade]['meta']).map(financiamento => modalidadesEncontradas[modalidade]['meta'][financiamento] += modalidades[modalidade]['meta'][financiamento])
                    Object.keys(modalidades[modalidade]['realizado']).map(financiamento => modalidadesEncontradas[modalidade]['realizado'][financiamento] += modalidades[modalidade]['realizado'][financiamento])
                }
                else {
                    modalidadesEncontradas[modalidade] = modalidades[modalidade]
                }
            })

        })
        delete modalidadesEncontradas.undefined
        realizados = modalidadesEncontradas
        return realizados;
    }

    formataRealizadoMetasV3 = (realizados, metas) => {
        let unidadesEncontradas = {}
        realizados.map(realizado => {
            let modalidades = realizado.modalidades;
            let unidade = realizado.unidade;
            Object.keys(modalidades).map(modalidade => {
                if(unidade === 'DR') return // não somar com o DR
                if(unidadesEncontradas.hasOwnProperty(unidade)) {
                    Object.keys(modalidades[modalidade]['meta']).map(financiamento => unidadesEncontradas[unidade]['meta'][financiamento] += modalidades[modalidade]['meta'][financiamento])
                    Object.keys(modalidades[modalidade]['realizado']).map(financiamento => unidadesEncontradas[unidade]['realizado'][financiamento] += modalidades[modalidade]['realizado'][financiamento])
                }
                else {
                    unidadesEncontradas[unidade] = modalidades[modalidade]
                }
            })
            
        })
        realizados = unidadesEncontradas
        return realizados;
    }

    defineTitulo = (tipo, modalidade) => {
        let texto;
        switch(tipo) {
            case 'regimental': texto = 'Gratuidade Regimental'; break
            case 'nao_regimental': texto = 'Gratuidade Não-Regimental'; break
            case 'pago': texto = 'Pagas'; break
        }
        return `${texto} (Consolidado por ${modalidade})`
    }

    render() {
        let { realizados, metas, ultimoMesApurado, mesSelecionado, radioChecked } = this.props

        
        let realizadosV3;
        if(realizados) {
            realizadosV3 = this.formataRealizadoMetasV3(JSON.parse(JSON.stringify(realizados)), JSON.parse(JSON.stringify(metas)));
            realizados = this.formataRealizadoMetasV2(JSON.parse(JSON.stringify(realizados)), JSON.parse(JSON.stringify(metas)));
        }
        
        let total = this.calculaTotal(realizados);

        return (
            <Fragment>

                <Tabs defaultActiveKey={"regimental"}>

                    {
                        ['regimental', 'pago', 'nao_regimental'].map((tipo, index) => {
                            return(
                                
                                <Tab eventKey={tipo} title={this.defineTitulo(tipo, 'Modalidade')}>
                                    <Tabela 
                                        realizados={realizados}
                                        total={total}
                                        tipo={tipo}
                                        tipoConsolidado={'Modalidade'}
                                        />
                                </Tab>
                            )
                        })
                    }

                    {
                        ['regimental', 'pago', 'nao_regimental'].map(tipo => {
                            return(
                                <Tab eventKey={this.defineTitulo(tipo, 'Unidade')} title={this.defineTitulo(tipo, 'Unidade')}>
                                    <Tabela 
                                        realizados={realizadosV3}
                                        total={total}
                                        tipo={tipo}
                                        tipoConsolidado={'Unidade'}
                                        />
                                </Tab>
                            )
                        })
                    }

                    

                </Tabs>

            </Fragment>
        )
    }

}